export class MyKnowledgeNotFoundError extends Error { }
